import { useFragment, graphql } from 'react-relay';
import { useItemPriceData } from '../../hooks/useItemPriceData';

import { type useShowIncludedLabelsInline_item$key } from './__generated__/useShowIncludedLabelsInline_item.graphql';
import { type useShowIncludedLabelsInline_displayPrice$key } from './__generated__/useShowIncludedLabelsInline_displayPrice.graphql';

const itemFragment = graphql`
    fragment useShowIncludedLabelsInline_item on Item {
        ...useItemPriceData_item
    }
`;

const displayPriceFragment = graphql`
    fragment useShowIncludedLabelsInline_displayPrice on ItemDisplayPriceType @relay(plural: true) {
        ...useItemPriceData_displayPrice
    }
`;

export const useShowIncludedLabelsInline = ({
    item: itemRef,
    displayPrice: displayPriceRef,
    currency,
}: {
    item?: useShowIncludedLabelsInline_item$key | null;
    displayPrice?: useShowIncludedLabelsInline_displayPrice$key | null;
    currency: string;
}): boolean => {
    const item = useFragment(itemFragment, itemRef);
    const displayPrice = useFragment(displayPriceFragment, displayPriceRef);

    const data = useItemPriceData({ item, displayPrice, currency });
    const { currentPrice, quantityLabel } = data || {};

    return currentPrice?.type === 'RETAIL' && !quantityLabel;
};
